import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const PDFExportButton = ({ chartRefs, type = "result", sessionData }) => {
  const exportPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    let y = 30;

    // Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(40);
    doc.setTextColor("#6893B4");
    doc.text(type === "result" ? "Session Report" : "Report History", 10, y);
    y += 20;

    for (const ref of chartRefs) {
      if (ref?.current) {
        const canvas = await html2canvas(ref.current);
        const imgData = canvas.toDataURL("image/png");
        const imgProps = doc.getImageProperties(imgData);
        const pdfWidth = doc.internal.pageSize.getWidth() - 20;
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        if (y + pdfHeight > 280) {
          doc.addPage();
          y = 10;
        }

        doc.addImage(imgData, "PNG", 10, y, pdfWidth, pdfHeight);
        y += pdfHeight + 10;
      }
    }

    y += 10;
    // Session Metrics
    doc.setFont("helvetica", "normal");
    doc.setFontSize(20);
    doc.setTextColor("#7D7D7D");
    if (type === "result") {
      const metrics = [
        `Average Left Force: ${sessionData.avgLeftForce}`,
        `Average Right Force: ${sessionData.avgRightForce}`,
      ];
      metrics.forEach((line) => {
        if (y > 280) {
          doc.addPage();
          y = 20;
        }
        doc.text(line, 10, y);
        y += 15;
      });
    } else if (type === "history") {
      for (const date in sessionData.history) {
        if (y > 280) {
          doc.addPage();
          y = 10;
        }

        // Print Date in bold
        doc.setFont("helvetica", "bold");
        doc.text(`Date: ${date}`, 10, y);
        y += 10;

        // Set regular font for the metrics
        doc.setFont("helvetica", "normal");

        const fields = [
          `Left Hip : ${sessionData.history[date]["leftHip"]}`,
          `Right Hip : ${sessionData.history[date]["rightHip"]}`,
          `Left Ankle : ${sessionData.history[date]["leftAnkle"]}`,
          `Right Ankle : ${sessionData.history[date]["rightAnkle"]}`,
          `Left Knee : ${sessionData.history[date]["leftKnee"]}`,
          `Right Knee : ${sessionData.history[date]["rightKnee"]}`,
        ];

        fields.forEach((line) => {
          if (y > 280) {
            doc.addPage();
            y = 10;
          }
          doc.text(line, 20, y); // 20 = indent
          y += 8;
        });

        y += 10; // Extra space after each date block
      }
    }
    y += 30;
    doc.text("", 10, y);
    doc.save(
      type === "result"
        ? `session_result_${new Date().toISOString()}.pdf`
        : `report_history_${new Date().toISOString()}.pdf`
    );
  };

  return (
    <button className="button1 white h3" onClick={exportPDF}>
      Export to PDF
    </button>
  );
};

export default PDFExportButton;
